import Nav from "./components/Nav";
import Banner from "./components/Banner.js";
import Clients from "./components/Clients";
import Benefits from "./components/Benefits";
import Courses from "./components/Courses";
import Faq from "./components/Faq";
import Work from "./components/Work";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  return (
    <>
      <Nav />
      <Banner />
      <Clients />
      <Benefits />
      <Courses />
      <Faq />
      <Work />
      <Footer />
    </>
  );
}

export default App;
